import { render, staticRenderFns } from "./orderAfterSales.vue?vue&type=template&id=0f7242c1&scoped=true"
import script from "./orderAfterSales.vue?vue&type=script&lang=js"
export * from "./orderAfterSales.vue?vue&type=script&lang=js"
import style0 from "./orderAfterSales.vue?vue&type=style&index=0&id=0f7242c1&prod&scoped=true&lang=css"
import style1 from "./orderAfterSales.vue?vue&type=style&index=1&id=0f7242c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7242c1",
  null
  
)

export default component.exports